import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type PartialStarIconProps = CreateIconComponentProps;

export const PartialStarIcon: React.FC<PartialStarIconProps> = ({
  title = 'Partial Star',
  viewBox = '0 0 50 50',
  color = 'currentColor',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    {/* prettier-ignore */}
    <>
      <path fill={color} fillOpacity=".01" d="M0 0h50v50H0z" /><path stroke={color} strokeWidth="3.125" d="m17.976 17.263.813-.118.363-.737 5.85-11.85 5.847 11.85.364.737.813.118 13.076 1.9-9.462 9.223-.589.573.14.81 2.233 13.024-11.696-6.149-.727-.382-.727.382-11.696 6.15 2.233-13.025.14-.81-.589-.573L4.9 19.163l13.076-1.9Zm7.18-13.02Z" /><path fill={color} fillRule="evenodd" d="M25 2.778c-.495 0-.99.259-1.244.775L17.75 15.717 4.327 17.668l-.104.02c-1.062.233-1.464 1.57-.665 2.35l9.713 9.467-2.292 13.372-.014.102c-.109 1.083 1.04 1.881 2.029 1.362L25 38.028V2.779Z" clipRule="evenodd" />
    </>
  </CreateIconComponent>
);

export default PartialStarIcon;
